import { apiFetch } from "./client";

export const subscribeNewsletter = (email) =>
  apiFetch("/enduser/subscribe/", {
    method: "POST",
    body: { email },
  });
